import React from 'react';

const MethodologyScreen = () => {
  return (
    <main role="main">
      <article className="prose lg:prose-xl text-white">
        <h2 className="font-mono mb-4">How are Rich Lists calculated?</h2>
        <p>
          Rich Lists have come a long way from the early days of hearsay and
          speculation to valuations powered by financial modelling and instant
          online data. Valuations still remain guesses on some level - for
          example the difficulty in measuring an individual's debt - so minimum
          estimates are usually chosen to provide a more conservative final
          amount. Any modern valuation would follow a process similar to this:
        </p>
        <ol className="mb-4">
          <li>
            Calculate public share holdings from listed company financial
            disclosures of major shareholders (easy if it’s available!);
          </li>
          <li>
            Calculate private company holdings, e.g. using a method like
            comparable company analysis (more difficult and room for
            discretion);
          </li>
          <li>
            Conduct paid searches in regulator databases (ASIC, state land
            registries) for private company holdings and property titles -
            searching for both Rich Listers and names of close
            family/associates;
          </li>
          <li>
            Scan media mentions for news on deals, property purchases,
            investments etc. (will depend on how high-profile or newsworthy the
            individual is);
          </li>
          <li>
            Apply generic inflation, cash rates, indexes to plug in any gaps
            (important for quiet Rich Listers who are rarely in the news);
          </li>
          <li>
            Make a final call on modifying the valuation that involves
            speaking to the Rick Lister in question, trusted sources or word on
            the street.
          </li>
        </ol>
        <h2 className="font-mono mb-4">Offical Sources</h2>
        <ul>
          <li>
            <a
              href="https://www.nineforbrands.com.au/media-release/the-australian-financial-review-rich-list-reveals-wealthiest-200"
              alt="The Australian Financial Review Rich List Reveals Wealthiest 200"
              className="font-bold underline"
            >
              The Australian Financial Review Rich List Reveals Wealthiest 200
            </a>
            <p>
              "The Rich List is calculated by the Rich List editors and a team
              of researchers. Valuations are minimum estimates calculated by
              using publicly available data and confidential consultation with
              those on the list. Listed company valuations are a three-month
              average calculated in the first week of April while valuations of
              private companies are typically determined using profit margins
              and price-earnings ratios of comparable publicly listed companies.
              Taxation and debt levels are also taken into account, with any
              assumptions based on the age, history and industries of the Rich
              List member."
            </p>
          </li>
          <li>
            <a
              href="https://www.forbes.com/sites/jenniferwang/2020/09/08/2020-forbes-400-methodology-how-we-crunch-the-numbers/?sh=513c397359b3"
              alt="The Australian Financial Review Rich List Reveals Wealthiest 200
"
              className="font-bold underline"
            >
              2020 Forbes 400 Methodology: How We Crunch The Numbers
            </a>
            <p>
              "When possible, we met with Forbes 400 members before the
              coronavirus pandemic and spoke with them virtually or by phone
              after. We also interviewed their employees, handlers, rivals,
              peers and attorneys. Uncovering their fortunes required us to pore
              over thousands of SEC documents, court records, probate records
              and news articles.
            </p>
            <p>
              We took into account all types of assets: stakes in public and
              private companies, real estate, art, yachts, planes, ranches,
              vineyards, jewelry, car collections and more. We factored in debt
              and charitable giving. While some billionaires provided
              documentation for their private assets and companies, others were
              less forthcoming. To value private businesses, we coupled revenue
              or profit estimates with prevailing price-to-sales,
              price-to-earnings, or similar ratios for similar public companies
              and applied a 10% discount, or more in cases where information is
              scarce."
            </p>
          </li>
          <li>
            <a
              href="https://www.ginarinehart.com.au/introduction-list-australias-richest-250/"
              alt="INTRODUCTION – THE LIST: AUSTRALIA’S RICHEST 250"
              className="font-bold underline"
            >
              INTRODUCTION – THE LIST: AUSTRALIA’S RICHEST 250
            </a>
            <p>
              "Public shareholdings are calculated on share prices up to
              February 15 this year, and property values and purchase prices
              have been derived from several public sources. Private companies,
              meanwhile, are valued using profit margins and various earnings
              ratios of comparable stock market listed competitors."
            </p>
          </li>
        </ul>
      </article>
    </main>
  );
};

export default MethodologyScreen;
